// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Vgp","question":"styles_question__3Grg2","inputVisibleButton":"styles_inputVisibleButton__2VDU6","note":"styles_note__1GQAc"};